<template>
    <div class="wrap">
        <div class="placeholder"></div>
        <div class="complaintBox">
            <div class="page_title" :style="pageLeftPx">
                <b>{{ pageTitle }}</b>
                <img class="titleImg autoC" src="../../../public/images/complaint/tab.png" />
                <el-button class="saveBtn" size="mini" type="primary" @click="editTxtFn" v-if="txtEditFlag">保 存</el-button>
            </div>
            <div class="search_box public_box" v-show="!txtEditFlag">
                <!--检索部分-->
                <el-form :inline="true" :model="navForm">
                    <el-form-item label="" class="dateBox">
                        <el-date-picker class="form_date" v-model="dateValue" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" @change="dateChange">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="(e) => searchTable()" style="margin-left: 0.2rem">查询</el-button>
                        <el-button type="primary" :loading="pdfLoading" @click="downloadFile" style="margin-left: 0.2rem">下载</el-button>
                        <el-button @click="editTxtFn" style="margin-left: 0.2rem" v-if="!txtEditFlag">编辑</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div id="targetEl" class="targetPdfContainer" v-if="pdfLoading">
                <complaint-pdf ref="complaintPdfRef" :queryData="navForm" :isTest="isTest" :chartsDictData="chartsDictData"></complaint-pdf>
            </div>
            <div id="charts_box" class="charts_box" v-show="1">
                <div class="chartBox public_box">
                    <div class="jiaoStyle">
                        <div class="jiao leftTop" style="top: 8px; left: 8px"></div>
                        <div class="jiao rightTop" style="top: 8px; right: 8px"></div>
                        <div class="jiao leftBottom" style="bottom: 0px; left: 8px"></div>
                        <div class="jiao rightBottom" style="bottom: 0px; right: 8px"></div>
                    </div>
                    <div class="chartTitle">投诉时间分布</div>
                    <div id="complaintChart1" class="complaintChartStyle" v-loading="chartLoading1" element-loading-spinner="el-icon-loading" element-loading-background="rgba(12, 36, 82, 0.8)"></div>
                </div>
                <div class="editBox" v-if="txtEditFlag">
                    <el-input v-model="chartsDictData.chart1.value" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入"></el-input>
                </div>
                <div class="chartBox public_box singleStyle" style="margin-top: -4px; height: 370px">
                    <div class="jiaoStyle" style="height: 368px">
                        <div class="jiao leftTop" style="top: 8px; left: 8px"></div>
                        <div class="jiao rightTop" style="top: 8px; right: 8px"></div>
                        <div class="jiao leftBottom" style="bottom: 0px; left: 8px"></div>
                        <div class="jiao rightBottom" style="bottom: 0px; right: 8px"></div>
                    </div>
                    <div class="chartTitle">投诉全量公估公司分布</div>
                    <div id="complaintChart2" class="complaintChartStyle" v-loading="chartLoading2" element-loading-spinner="el-icon-loading" element-loading-background="rgba(12, 36, 82, 0.8)"></div>
                </div>
                <div class="editBox" v-if="txtEditFlag">
                    <el-input v-model="chartsDictData.chart2.value" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入"></el-input>
                </div>
                <div class="tableBox chartBox public_box" style="margin-top: -4px; height: 455px">
                    <div class="jiaoStyle" style="height: 455px">
                        <div class="jiao leftTop" style="top: 8px; left: 8px"></div>
                        <div class="jiao rightTop" style="top: 8px; right: 8px"></div>
                        <div class="jiao leftBottom" style="bottom: 0px; left: 8px"></div>
                        <div class="jiao rightBottom" style="bottom: 0px; right: 8px"></div>
                    </div>
                    <div class="chartTitle">投诉全量渠道分布</div>
                    <div id="complaintChart4" class="complaintChartStyle chartStyle4" v-loading="chartLoading2" element-loading-spinner="el-icon-loading" element-loading-background="rgba(12, 36, 82, 0.8)"></div>
                </div>
                <div class="editBox" v-if="txtEditFlag">
                    <el-input v-model="chartsDictData.chart3.value" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入"></el-input>
                </div>
                <div class="tablesBox clearfix" style="margin-top: -4px; margin-bottom: 20px">
                    <div class="left_tableBox public_box fl">
                        <div class="jiaoStyle">
                            <div class="jiao leftTop" style="top: 8px; left: 8px"></div>
                            <div class="jiao rightTop" style="top: 8px; right: 8px"></div>
                            <div class="jiao leftBottom" style="bottom: 0px; left: 8px"></div>
                            <div class="jiao rightBottom" style="bottom: 0px; right: 8px"></div>
                        </div>
                        <div class="chartTitle">公估公司投诉原因</div>
                        <el-table class="chartTable fontTableStyle" :data="tableData4" max-height="270px" stripe v-loading="tableLoading4">
                            <el-table-column prop="company" label="公估公司"> </el-table-column>
                            <el-table-column prop="timeDispute" label="时效争议"> </el-table-column>
                            <el-table-column prop="amountDispute" label="金额争议"> </el-table-column>
                            <el-table-column prop="responsibilityDispute" label="责任争议"> </el-table-column>
                            <el-table-column prop="serviceProcess" label="服务流程"> </el-table-column>
                            <el-table-column prop="serviceQuality" label="服务品质"> </el-table-column>
                        </el-table>
                    </div>
                    <div class="right_tableBox public_box fr">
                        <div class="jiaoStyle">
                            <div class="jiao leftTop" style="top: 8px; left: 8px"></div>
                            <div class="jiao rightTop" style="top: 8px; right: 8px"></div>
                            <div class="jiao leftBottom" style="bottom: 2px; left: 8px"></div>
                            <div class="jiao rightBottom" style="bottom: 2px; right: 8px"></div>
                        </div>
                        <div class="chartTitle">具体争议占比</div>
                        <div id="complaintChart3" class="complaintChartStyle" v-loading="chartLoading3"></div>
                    </div>
                </div>
                <div class="editBox clearfix" v-if="txtEditFlag">
                    <div class="left_edit fl">
                        <el-input v-model="chartsDictData.table1.value" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入"></el-input>
                    </div>
                    <div class="right_edit fr">
                        <el-input v-model="chartsDictData.chart4.value" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="tablesBox clearfix" style="margin-top: -4px; margin-bottom: 20px">
                    <div class="left_tableBox public_box fl">
                        <div class="jiaoStyle">
                            <div class="jiao leftTop" style="top: 8px; left: 8px"></div>
                            <div class="jiao rightTop" style="top: 8px; right: 8px"></div>
                            <div class="jiao leftBottom" style="bottom: 0px; left: 8px"></div>
                            <div class="jiao rightBottom" style="bottom: 0px; right: 8px"></div>
                        </div>
                        <div class="chartTitle">公估公司投诉角色</div>
                        <el-table class="chartTable fontTableStyle" :data="tableData4_1" max-height="270px" stripe v-loading="tableLoading4_1">
                            <el-table-column prop="company" label="公估公司"> </el-table-column>
                            <el-table-column prop="rider" label="骑手" width="55"> </el-table-column>
                            <el-table-column prop="thirdParty" label="三者" width="55"> </el-table-column>
                            <el-table-column prop="riderFamily" label="骑手家属"> </el-table-column>
                            <el-table-column prop="thirdPartyFamily" label="三者家属"> </el-table-column>
                            <el-table-column prop="riderAgent" label="骑手代理人"> </el-table-column>
                            <el-table-column prop="thirdPartyAgent" label="三者代理人"> </el-table-column>
                            <el-table-column prop="serviceProvider" label="服务商" width="70"> </el-table-column>
                            <el-table-column prop="foodLiabilityInsuranceCustomer" label="食责险客户"> </el-table-column>
                            <el-table-column prop="repairShop" label="修理厂"> </el-table-column>
                            <el-table-column prop="other" label="其他" width="55"> </el-table-column>
                        </el-table>
                    </div>
                    <div class="right_tableBox public_box fr">
                        <div class="jiaoStyle">
                            <div class="jiao leftTop" style="top: 8px; left: 8px"></div>
                            <div class="jiao rightTop" style="top: 8px; right: 8px"></div>
                            <div class="jiao leftBottom" style="bottom: 2px; left: 8px"></div>
                            <div class="jiao rightBottom" style="bottom: 2px; right: 8px"></div>
                        </div>
                        <div class="chartTitle">投诉角色占比</div>
                        <div id="complaintChart5" class="complaintChartStyle" v-loading="chartLoading5"></div>
                    </div>
                </div>
                <div class="editBox clearfix" v-if="txtEditFlag">
                    <div class="left_edit fl">
                        <el-input v-model="chartsDictData.table4.value" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入"></el-input>
                    </div>
                    <div class="right_edit fr">
                        <el-input v-model="chartsDictData.chart5.value" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="tableBox public_box" style="margin-top: -4px; height: 455px">
                    <div class="jiaoStyle" style="height: 453px">
                        <div class="jiao leftTop" style="top: 8px; left: 8px"></div>
                        <div class="jiao rightTop" style="top: 8px; right: 8px"></div>
                        <div class="jiao leftBottom" style="bottom: 0px; left: 8px"></div>
                        <div class="jiao rightBottom" style="bottom: 0px; right: 8px"></div>
                    </div>
                    <div class="chartTitle">投诉渠道信息统计</div>
                    <el-table class="chartTable" :data="tableData2" max-height="390px" stripe v-loading="tableLoading2">
                        <el-table-column prop="company" label="公估公司" width="180"> </el-table-column>
                        <el-table-column prop="nine5550WorkOrder" label="95500工单"> </el-table-column>
                        <el-table-column prop="formalComplaint" label="正式投诉"> </el-table-column>
                        <el-table-column prop="regulatoryConsultation" label="监管咨询"> </el-table-column>
                        <el-table-column prop="regulatoryFormal" label="监管正式"> </el-table-column>
                        <el-table-column prop="externalPublicOpinion" label="外部舆情"> </el-table-column>
                        <el-table-column prop="regulatoryFormal" label="扬言监管"> </el-table-column>
                        <el-table-column prop="consumerProtectionGuide" label="消保引导"> </el-table-column>
                        <el-table-column prop="consumerProtectionFormal" label="消保正式"> </el-table-column>
                        <el-table-column prop="total" label="合计"> </el-table-column>
                    </el-table>
                </div>
                <div class="editBox" v-if="txtEditFlag">
                    <el-input v-model="chartsDictData.table2.value" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入"></el-input>
                </div>
                <div class="tableBox public_box" style="margin-top: -4px; height: 460px">
                    <div class="jiaoStyle" style="height: 450px">
                        <div class="jiao leftTop" style="top: 8px; left: 8px"></div>
                        <div class="jiao rightTop" style="top: 8px; right: 8px"></div>
                        <div class="jiao leftBottom" style="bottom: 0px; left: 8px"></div>
                        <div class="jiao rightBottom" style="bottom: 0px; right: 8px"></div>
                    </div>
                    <div class="chartTitle">投诉协助案件</div>
                    <el-table class="chartTable" :data="tableData3" max-height="390px" stripe v-loading="tableLoading3">
                        <el-table-column prop="assistancePerson" label="协助人" width="180"> </el-table-column>
                        <el-table-column prop="nine5550WorkOrder" label="95500工单"> </el-table-column>
                        <el-table-column prop="formalComplaint" label="正式投诉"> </el-table-column>
                        <el-table-column prop="regulatoryConsultation" label="监管咨询"> </el-table-column>
                        <el-table-column prop="regulatoryFormal" label="监管正式"> </el-table-column>
                        <el-table-column prop="externalPublicOpinion" label="外部舆情"> </el-table-column>
                        <el-table-column prop="regulatoryFormal" label="扬言监管"> </el-table-column>
                        <el-table-column prop="consumerProtectionGuide" label="消保引导"> </el-table-column>
                        <el-table-column prop="consumerProtectionFormal" label="消保正式"> </el-table-column>
                        <el-table-column prop="total" label="总数"> </el-table-column>
                        <el-table-column prop="totalAmount" label="总金额"> </el-table-column>
                    </el-table>
                </div>
                <div class="editBox" v-if="txtEditFlag">
                    <el-input v-model="chartsDictData.table3.value" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入"></el-input>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import * as echarts from 'echarts';
import ComplaintPdf from './complaintStatisticsCopy.vue';
import html2Canvas from 'html2canvas';
import jsPDF from 'jspdf';
export default {
    name: 'offerStatistics',
    components: { ComplaintPdf },
    props: {
        isCollapse: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isTest: false,
            txtEditFlag: false,
            pageLeftPx: '1px',
            pageTitle: '',
            pdfLoading: false,
            chartLoading1: false,
            chartLoading2: false,
            chartLoading3: false,
            chartLoading4: false,
            chartLoading5: false,
            tableLoading1: false,
            tableLoading2: false,
            tableLoading3: false,
            tableLoading4: false,
            tableLoading4_1: false,
            complaintChart1: null,
            complaintChart2: null,
            complaintChart3: null,
            complaintChart4: null,
            complaintChart5: null,
            dateValue: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            navForm: {
                startDay: null,
                endDay: null
            },
            tableData1: [],
            tableData2: [],
            tableData3: [],
            tableData4: [],
            tableData4_1: [],
            dictData: {},
            chartsDictData: {
                chart1: {
                    label: '投诉时间分布',
                    value: null
                },
                chart2: {
                    label: '投诉全量公估公司分布',
                    value: null
                },
                chart3: {
                    label: '投诉全量渠道分布',
                    value: null
                },
                chart4: {
                    label: '投诉原因占比',
                    value: null
                },
                chart5: {
                    label: '投诉角色占比',
                    value: null
                },
                table1: {
                    label: '公估公司投诉原因',
                    value: null
                },
                table2: {
                    label: '投诉渠道信息统计',
                    value: null
                },
                table3: {
                    label: '投诉协助案件',
                    value: null
                },
                table4: {
                    label: '投诉公司投诉角色',
                    value: null
                }
            }
        };
    },
    mounted() {
        this.pageTitle = this.$route.meta.title;
        const date = new Date();
        const yesterday = new Date(date);

        // 设置为前一天
        yesterday.setDate(date.getDate() - 1);
        let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 30);
        this.dateValue = [this.dateFormatting(startDate, 'yyyy-MM-dd'), this.dateFormatting(yesterday, 'yyyy-MM-dd')];
        // this.dateValue = ['2025-01-06', '2025-05-06'];
        this.dateChange(this.dateValue);

        this.renderCharts();

        window.addEventListener('resize', () => {
            this.complaintChart1 && this.complaintChart1.resize();
            this.complaintChart2 && this.complaintChart2.resize();
            this.complaintChart3 && this.complaintChart3.resize();
            this.complaintChart4 && this.complaintChart4.resize();
        });
    },
    methods: {
        editTxtFn() {
            if (this.txtEditFlag) {
                this.saveStorageDict();
            } else {
                this.queryStorageDict(true);
            }
        },
        queryStorageDict(showChartsFlag) {
            this.instance.post('/complaintInfo/findTemporaryStorageDict', {}).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.dictData = data.data;
                    if (data.data.metaData) {
                        let metaData = JSON.parse(data.data.metaData);
                        // this.chartsDictData = JSON.parse(data.data.metaData);
                        for (const key in this.chartsDictData) {
                            if (metaData[key]) {
                                this.chartsDictData[key].value = metaData[key].value;
                            } else {
                                this.chartsDictData[key].value = null;
                            }
                        }
                    }
                    if (showChartsFlag) {
                        this.txtEditFlag = true;
                    }

                    if (showChartsFlag) {
                        this.$nextTick(() => {
                            this.renderCharts();
                        });
                    }
                }
            });
        },
        saveStorageDict() {
            this.dictData.metaData = JSON.stringify(this.chartsDictData);
            this.instance.post('/complaintInfo/updateTemporaryStorageDict', this.dictData).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.$message.success('保存成功！');
                    this.txtEditFlag = false;
                    this.$nextTick(() => {
                        this.renderCharts(true);
                    });
                } else {
                    this.$message.error(data.message);
                }
            });
        },
        dateChange(val) {
            if (val) {
                this.navForm = {
                    startDay: val[0],
                    endDay: val[1]
                };
            } else {
                this.navForm = {
                    startDay: null,
                    endDay: null
                };
            }
        },
        convertPDF() {
            html2Canvas(document.querySelector('#targetEl'), {
                allowTaint: false,
                taintTest: false,
                logging: false,
                useCORS: true,
                dpi: window.devicePixelRatio * 5, //将分辨率提高到特定的DPI 提高四倍
                scale: 3 //按比例增加分辨率
            }).then((canvas) => {
                var pdf = new jsPDF('p', 'mm', 'a4', true); //A4纸，纵向
                // a4w = 190,
                // a4h = 287,
                var ctx = canvas.getContext('2d'),
                    a4w = 190,
                    a4h = 287, //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
                    imgHeight = Math.floor((a4h * canvas.width) / a4w), //按A4显示比例换算一页图像的像素高度
                    renderedHeight = 0;
                while (renderedHeight < canvas.height) {
                    var page = document.createElement('canvas');
                    page.width = canvas.width;
                    page.height = Math.min(imgHeight, canvas.height - renderedHeight); //可能内容不足一页
                    //用 getImageData 剪裁指定区域，并画到前面创建的canvas对象中
                    page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
                    pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 0, a4w, Math.min(a4h, (a4w * page.height) / page.width)); //添加图像到页面，保留10mm边距

                    renderedHeight += imgHeight;
                    if (renderedHeight < canvas.height) {
                        pdf.addPage(); //如果后面还有内容，添加一个空页
                    }
                    // delete page;
                }
                this.pdfBlob = pdf.output('blob');
                console.log('pdf转换完成');
                this.pdfLoading = false;
                // window.pdfBlob = pdf.output('blob')
                //保存文件
                pdf.save('投诉信息分析统计.pdf');
            });
        },
        downloadFile() {
            if (this.pdfLoading) {
                return;
            }
            this.pdfLoading = true;
            this.queryStorageDict();
            setTimeout(() => {
                this.convertPDF();
            }, 2000);
        },
        //点击查询
        searchTable(clearFlag) {
            if (!this.navForm.startDay) {
                this.$message.warning('抱歉，请选择查询开始时间！');
                return false;
            }
            if (!this.navForm.endDay) {
                this.$message.warning('抱歉，请选择查询结束时间！');
                return false;
            }

            setTimeout(() => {
                this.$nextTick(() => {
                    if (this.$refs.complaintPdfRef) {
                        this.$refs.complaintPdfRef.searchTable();
                    }
                });
            }, 3000);

            if (clearFlag) {
                this.complaintChart1.dispose();
                this.complaintChart1 = null;
                this.complaintChart2.dispose();
                this.complaintChart2 = null;
                this.complaintChart3.dispose();
                this.complaintChart3 = null;
                this.complaintChart4.dispose();
                this.complaintChart4 = null;
                this.complaintChart5.dispose();
                this.complaintChart5 = null;
            }

            this.getComplaintTime();
            this.getComplaintCompany();
            this.getComplaintChannels();
            this.getComplaintChannelInfo();
            this.getComplaintAssistanceCases();
            this.getCompanyCause();
            this.getComplaintCause();

            this.getComplaintCompanyId();
            this.getComplaintIdCard();
        },
        renderCharts(clearFlag) {
            if (this.isTest) {
                this.testSearch(clearFlag);
            } else {
                this.searchTable(clearFlag);
            }
        },
        testSearch(clearFlag) {
            if (clearFlag) {
                this.complaintChart1.dispose();
                this.complaintChart1 = null;
                this.complaintChart2.dispose();
                this.complaintChart2 = null;
                this.complaintChart3.dispose();
                this.complaintChart3 = null;
                this.complaintChart4.dispose();
                this.complaintChart4 = null;
                this.complaintChart5.dispose();
                this.complaintChart5 = null;
                this.setChart1(chartsData1.data);
                this.setChart2(chartsData2.data);
                this.setChart3(chartsData3.data);
                this.setChart4(tmpTableData1.data);
                this.setChart5(chartsData4.data);
            } else {
                this.setChart1(chartsData1.data);
                this.setChart2(chartsData2.data);
                this.setChart3(chartsData3.data);
                this.setChart4(tmpTableData1.data);
                this.setChart5(chartsData4.data);
            }
            this.tableData1 = tmpTableData1.data;
            this.tableData2 = tmpTableData2.data;
            this.tableData3 = tmpTableData3.data;
            this.tableData4 = tmpTableData4.data;
            this.tableData4_1 = tmpTableData4_1.data;
        },
        getComplaintTime() {
            this.chartLoading1 = true;
            this.instance.post('/complaintInfo/complaintTimeDistribution', this.navForm).then((res) => {
                this.chartLoading1 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.setChart1(data.data);
                }
            });
        },
        getComplaintCompany() {
            this.chartLoading2 = true;
            this.instance.post('/complaintInfo/complaintCompanyDistribution', this.navForm).then((res) => {
                this.chartLoading2 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.setChart2(data.data);
                }
            });
        },
        getComplaintCompanyId() {
            this.tableLoading4_1 = true;
            this.instance.post('/complaintInfo/complaintCompanyIdCardDistribution', this.navForm).then((res) => {
                this.tableLoading4_1 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.tableData4_1 = data.data;
                } else {
                    this.tableData4_1 = [];
                }
            });
        },
        getComplaintIdCard() {
            this.tableLoading5 = true;
            this.instance.post('/complaintInfo/complaintIdCardDistribution', this.navForm).then((res) => {
                this.tableLoading5 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.setChart5(data.data);
                }
            });
        },
        getComplaintChannels() {
            this.tableLoading1 = true;
            this.instance.post('/complaintInfo/complaintChannelsDistribution', this.navForm).then((res) => {
                this.tableLoading1 = false;
                let data = res.data;
                if (data.code == 1) {
                    // this.tableData1 = data.data;
                    this.setChart4(data.data);
                } else {
                    this.tableData1 = [];
                }
            });
        },
        getComplaintChannelInfo() {
            this.tableLoading2 = true;
            this.instance.post('/complaintInfo/complaintChannelInfoDistribution', this.navForm).then((res) => {
                this.tableLoading2 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.tableData2 = data.data;
                } else {
                    this.tableData2 = [];
                }
            });
        },
        getComplaintAssistanceCases() {
            this.tableLoading3 = true;
            this.instance.post('/complaintInfo/complaintAssistanceCases', this.navForm).then((res) => {
                this.tableLoading3 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.tableData3 = data.data;
                } else {
                    this.tableData3 = [];
                }
            });
        },
        getCompanyCause() {
            this.tableLoading4 = true;
            this.instance.post('/complaintInfo/complaintCompanyCauseDistribution', this.navForm).then((res) => {
                this.tableLoading4 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.tableData4 = data.data;
                } else {
                    this.tableData4 = [];
                }
            });
        },
        getComplaintCause() {
            this.chartLoading3 = false;
            this.instance.post('/complaintInfo/complaintCauseDistribution', this.navForm).then((res) => {
                this.chartLoading3 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.setChart3(data.data);
                }
            });
        },
        setChart1(resData) {
            // 计算日期范围天数
            function getDateRangeDays(start, end) {
                const startDate = new Date(start);
                const endDate = new Date(end);
                const diffTime = Math.abs(endDate - startDate);
                return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            }
            let days = 0;
            if (this.navForm.startDay && this.navForm.endDay) {
                days = getDateRangeDays(this.navForm.startDay, this.navForm.endDay);
            }
            let xAxisData = [],
                seriesData1 = [],
                seriesData2 = [],
                seriesData3 = [],
                legendData = ['投诉全量', '诉求工单', '报案量'];

            if (!resData) {
                return;
            }

            resData.forEach((item) => {
                xAxisData.push(item.time);
                seriesData1.push(item.reportNum || 0);
                seriesData2.push(item.complaintNum || 0);
                seriesData3.push(item.complaintFormNum || 0);
            });

            let chartDom = document.getElementById('complaintChart1');
            this.complaintChart1 = echarts.init(chartDom);

            let colorArr = ['#FAC859', '#409EFE', '#91CB74'];
            let option = {
                textStyle: {
                    fontSize: 14 // 全局文字大小
                },
                color: colorArr,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                legend: {
                    data: legendData,
                    textStyle: {
                        color: '#fff', // 图例文字颜色
                        fontSize: 14 // 可选：文字大小
                    },
                    bottom: 0 // 距离底部距离
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '15%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisData,
                        axisLabel: {
                            rotate: days > 30 ? 45 : 0, // 关键配置：超过30天则倾斜45度
                            interval: days > days * 10 ? 10 : 0 // 超过30天则自动稀疏显示
                        },
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff' // X 轴轴线颜色
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#fff' // X 轴刻度线颜色
                            }
                        },
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#fff',
                            fontSize: 14
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#fff' // Y 轴网格线颜色
                            }
                        }
                    },
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#FAC859',
                            fontSize: 14
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#fff' // Y 轴网格线颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '报案量',
                        type: 'line',
                        label: {
                            show: true, // 显示数值标签
                            position: 'bottom', // 标签位置（柱状图顶部）
                            color: '#fff' // 标签颜色
                        },
                        yAxisIndex: 1,
                        data: seriesData1
                    },
                    {
                        name: '投诉全量',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top', // 标签位置（柱状图顶部）
                            color: '#fff' // 标签颜色
                        },
                        barMaxWidth: 40,
                        barGap: 0,
                        data: seriesData2
                    },
                    {
                        name: '诉求工单',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top', // 标签位置（柱状图顶部）
                            color: '#fff' // 标签颜色
                        },
                        barMaxWidth: 40,
                        data: seriesData3
                    }
                ]
            };
            this.complaintChart1.setOption(option);
        },
        setChart2(resData) {
            let xAxisData = [],
                seriesData1 = [],
                seriesData2 = [],
                legendData = ['诉求工单', '投诉全量'];

            if (!resData) {
                return;
            }

            resData.forEach((item) => {
                xAxisData.push(item.company);
                seriesData1.push(item.complaintNum || 0);
                seriesData2.push(item.complaintFormNum || 0);
            });

            let chartDom = document.getElementById('complaintChart2');
            this.complaintChart2 = echarts.init(chartDom);

            let option = {
                textStyle: {
                    fontSize: 14 // 全局文字大小
                },
                color: ['#409EFE', '#FAC859'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                legend: {
                    data: legendData,
                    textStyle: {
                        color: '#fff', // 图例文字颜色
                        fontSize: 14 // 可选：文字大小
                    },
                    bottom: 0 // 距离底部距离
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '15%',
                    top: '10%',
                    containLabel: true // 是否包含坐标轴标签
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisData,
                        axisLine: {
                            lineStyle: {
                                color: '#fff' // X 轴轴线颜色
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#fff' // X 轴刻度线颜色
                            }
                        },
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#fff',
                            fontSize: 14
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#fff' // Y 轴网格线颜色
                            }
                        }
                    },
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#FAC859',
                            fontSize: 14
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#fff' // Y 轴网格线颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '诉求工单',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top', // 标签位置（柱状图顶部）
                            color: '#fff' // 标签颜色
                        },
                        barMaxWidth: 40, // 最大不超过80像素
                        data: seriesData2
                    },
                    {
                        name: '投诉全量',
                        type: 'line',
                        label: {
                            show: true, // 显示数值标签
                            position: 'bottom', // 标签位置（柱状图顶部）
                            color: '#fff' // 标签颜色
                        },
                        yAxisIndex: 1,
                        data: seriesData1
                    }
                ]
            };
            this.complaintChart2.setOption(option);
        },
        setChart3(resData) {
            let xAxisData = [],
                seriesData1 = [],
                seriesData2 = [],
                legendData = ['投诉全量', '诉求工单'];

            if (!resData) {
                return;
            }

            // 处理数据，保留原属性并新增value和name
            seriesData1 = resData.map((item) => ({
                ...item, // 保留原有的所有属性
                name: item.specificDisputes, // name对应specificDisputes
                value: item.specificDisputesNums || 0 // value对应specificDisputesNums
            }));

            let chartDom = document.getElementById('complaintChart3');
            this.complaintChart3 = echarts.init(chartDom);

            let option = {
                textStyle: {
                    fontSize: 14
                },
                grid: {
                    left: '20%',
                    right: '10%',
                    top: '10%',
                    bottom: '10%'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        center: ['50%', '55%'],
                        data: seriesData1,
                        avoidLabelOverlap: true,
                        label: {
                            color: '#fff',
                            alignTo: 'radial',
                            // formatter: '{b}\n{c} ({d}%)',
                            formatter: '{b}\n{d}%',
                            lineHeight: 15
                        },
                        labelLine: {
                            show: true,
                            length: 20,
                            length2: 60,
                            lineStyle: {
                                width: 1
                            }
                        }
                    }
                ]
            };
            this.complaintChart3.setOption(option);
        },
        setChart4(resData) {
            let xAxisData = [],
                seriesData1 = [],
                seriesData2 = [],
                seriesData3 = [],
                seriesData4 = [],
                seriesData5 = [],
                legendData = ['诉求工单', '内部投诉', '外部投诉'];

            if (!resData) {
                return;
            }

            resData.forEach((item) => {
                if (item.company != '合计') {
                    // 公估公司
                    xAxisData.push(item.company);
                    // 投诉全量
                    // seriesData1.push(item.complaintNum);
                    // 外部投诉
                    seriesData2.push(item.externalNum);
                    // 内部投诉
                    seriesData3.push(item.internalNum);
                    // 诉求工单
                    seriesData4.push(item.complaintFormNum);
                    // 投诉占比
                    // seriesData5.push(item.ratio);
                }
            });

            let chartDom = document.getElementById('complaintChart4');

            this.complaintChart4 = echarts.init(chartDom);

            let colorArr = ['#FAC859', '#409EFE', '#91CB74', '#E97CCB', '#72C0DE'];
            let option = {
                textStyle: {
                    fontSize: 14 // 全局文字大小
                },
                color: colorArr,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                legend: {
                    data: legendData,
                    textStyle: {
                        color: '#fff', // 图例文字颜色
                        fontSize: 14 // 可选：文字大小
                    },
                    bottom: 0 // 距离底部距离
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '10%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisData,
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff' // X 轴轴线颜色
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#fff' // X 轴刻度线颜色
                            }
                        },
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#fff',
                            fontSize: 14
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#fff' // Y 轴网格线颜色
                            }
                        }
                    },
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#2BE2DF',
                            fontSize: 14
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#fff' // Y 轴网格线颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '诉求工单',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top',
                            rotate: 90,
                            align: 'left',
                            verticalAlign: 'middle', // 标签位置（柱状图顶部）
                            color: '#FAC859' // 标签颜色
                        },
                        barMaxWidth: 40,
                        barGap: 0,
                        data: seriesData4
                    },
                    {
                        name: '内部投诉',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top',
                            rotate: 90,
                            align: 'left',
                            verticalAlign: 'middle', // 标签位置（柱状图顶部）
                            color: '#409EFE' // 标签颜色
                        },
                        barMaxWidth: 40,
                        data: seriesData3
                    },
                    {
                        name: '外部投诉',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top',
                            rotate: 90,
                            align: 'left',
                            verticalAlign: 'middle', // 标签位置（柱状图顶部）
                            color: '#91CB74' // 标签颜色
                        },
                        barMaxWidth: 40,
                        barGap: 0,
                        data: seriesData2
                    },
                    {
                        name: '投诉全量',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top',
                            rotate: 90,
                            align: 'left',
                            verticalAlign: 'middle', // 标签位置（柱状图顶部）
                            color: '#E97CCB' // 标签颜色
                        },
                        yAxisIndex: 1,
                        barMaxWidth: 40,
                        data: seriesData1
                    },
                    {
                        name: '投诉占比（%）',
                        type: 'line',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top', // 标签位置（柱状图顶部）
                            color: '#fff' // 标签颜色
                            // 自定义标签显示格式，带单位
                            // formatter: function (params) {
                            //     return params.value + ' %';
                            // }
                        },
                        barMaxWidth: 40,
                        data: seriesData5
                    }
                ]
            };
            this.complaintChart4.setOption(option);
        },
        setChart5(resData) {
            let xAxisData = [],
                seriesData1 = [],
                seriesData2 = [],
                legendData = ['投诉全量', '诉求工单'];

            if (!resData) {
                return;
            }

            seriesData1 = [
                { value: resData['rider'] || 0, name: '骑手' },
                { value: resData['thirdParty'] || 0, name: '三者' },
                { value: resData['riderFamily'] || 0, name: '骑手家属' },
                { value: resData['thirdPartyFamily'] || 0, name: '三者家属' },
                { value: resData['riderAgent'] || 0, name: '骑手代理人' },
                { value: resData['thirdPartyAgent'] || 0, name: '三者代理人' },
                { value: resData['serviceProvider'] || 0, name: '服务商' },
                { value: resData['foodLiabilityInsuranceCustomer'] || 0, name: '食责险客户' },
                { value: resData['repairShop'] || 0, name: '修理厂' },
                { value: resData['other'] || 0, name: '其他' }
            ];

            let chartDom = document.getElementById('complaintChart5');
            this.complaintChart5 = echarts.init(chartDom);

            let option = {
                textStyle: {
                    fontSize: 14
                },
                grid: {
                    left: '20%',
                    right: '10%',
                    top: '10%',
                    bottom: '10%'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        center: ['50%', '55%'],
                        data: seriesData1,
                        avoidLabelOverlap: true,
                        label: {
                            color: '#fff',
                            alignTo: 'radial',
                            // formatter: '{b}\n{c} ({d}%)',
                            formatter: '{b}\n{d}%',
                            lineHeight: 15
                        },
                        labelLine: {
                            show: true,
                            length: 30,
                            length2: 100,
                            lineStyle: {
                                // color: '#999',
                                width: 1
                            }
                        }
                    }
                ]
            };
            this.complaintChart5.setOption(option);
        }
    },
    watch: {
        isCollapse: {
            handler(val) {
                let isElTime = setInterval(() => {
                    let pageEl = document.querySelector('.menus');
                    if (val && pageEl && pageEl.offsetWidth == 64) {
                        this.pageLeftPx = `left:${pageEl.offsetWidth}px;width:calc(100% - 64px)`;
                        clearInterval(isElTime);
                    }
                    if (!val && pageEl && pageEl.offsetWidth == 200) {
                        this.pageLeftPx = `left:${pageEl.offsetWidth}px;width:calc(100% - 200px)`;
                        clearInterval(isElTime);
                    }
                }, 10);
            },
            immediate: true
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../assets/css/table_public.css';
.placeholder {
    height: 60px;
    width: 100%;
    background: #0c2452;
}
.targetPdfContainer {
    position: absolute;
    left: -1000px;
    top: -5000px;
    z-index: -1;

    // left: 0;
    // top: 100px;
    // z-index: 999;
}
.complaintBox {
    background: #0c2452;
    padding: 0 10px;
    height: calc(100vh - 120px);
    overflow-y: auto;
    margin-bottom: -10px;
    min-width: 1390px;

    .page_title {
        text-align: center;
        padding-top: 20px;
        position: fixed;
        top: 0.8rem;
        margin-bottom: -20px;
        z-index: 99;
        height: 50px;
        b {
            color: #fff;
            font-size: 26px;
            font-weight: bold;
            letter-spacing: 8px;
            position: relative;
            z-index: 3;
            top: -14px;
        }
        .titleImg {
            // width: 700px;
            height: 50px;
            top: -53px;
        }
        .saveBtn {
            position: absolute;
            left: 40px;
            top: 40px;
            z-index: 15;
        }
    }
    .search_box {
        margin-top: 0;
        padding-top: 0;
        padding-bottom: 0;
        background: #0c2452;
        .form_date {
            width: 290px;
            background: #0c2452ed;
            color: #fff;
            /deep/ input {
                background: #0c2452 !important;
            }
            /deep/ * {
                color: #fff;
            }
        }
    }
}
.chartTitle {
    margin-bottom: 10px;
    // color: #409eff !important;
    color: #7dbdff !important;
    font-size: 20px;
    font-weight: bold;
}
.chartTitle::before {
    display: inline-block;
    content: '';
    width: 4px;
    height: 17px;
    background: #409eff;
    border-radius: 3px;
    margin-right: 0.12rem;
    position: relative;
    top: 2px;
}
.jiaoStyle {
    width: 100%;
    height: 342px;
    position: absolute;
    left: 0;
    top: 0;
    .jiao {
        width: 20px;
        height: 2px;
        background: #25e9ee;
        position: absolute;
        z-index: 5;
        box-shadow: 0 0 5px rgba(37, 233, 238, 0.5), 0 0 10px rgba(37, 233, 238, 0.4), 0 0 15px rgba(37, 233, 238, 0.3), 0 0 0 1px rgba(37, 233, 238, 0.2);
        animation: glow 2s infinite alternate ease-in-out;
    }
    .jiao::before {
        background: #25e9ee;
        box-shadow: 0 0 5px rgba(37, 233, 238, 0.5), 0 0 10px rgba(37, 233, 238, 0.4), 0 0 15px rgba(37, 233, 238, 0.3), 0 0 0 1px rgba(37, 233, 238, 0.2);
        animation: glow 2s infinite alternate ease-in-out;
    }
    .leftTop {
        top: 0;
    }
    .leftTop::before {
        content: '';
        display: inline-block;
        width: 19px;
        height: 2px;
        position: absolute;
        transform: rotate(90deg);
        left: -9px;
        top: 9px;
    }

    .rightTop {
        top: 0;
        right: 0;
    }
    .rightTop::before {
        content: '';
        display: inline-block;
        width: 19px;
        height: 2px;
        position: absolute;
        transform: rotate(90deg);
        right: -9px;
        top: 9px;
    }

    .leftBottom {
        bottom: 0px;
    }
    .leftBottom::before {
        content: '';
        display: inline-block;
        width: 19px;
        height: 2px;
        position: absolute;
        transform: rotate(90deg);
        left: -9px;
        bottom: 9px;
    }

    .rightBottom {
        bottom: 0px;
        right: 0;
    }
    .rightBottom::before {
        content: '';
        display: inline-block;
        width: 19px;
        height: 2px;
        position: absolute;
        transform: rotate(90deg);
        right: -9px;
        bottom: 9px;
    }
}
.public_box {
    position: relative;
    border: 0;
    box-shadow: none;
    background: #0c2452;
}
.charts_null {
    text-align: center;
    font-size: 0.2rem;
    color: #666;
    line-height: 3.3rem;
}
.null_data {
    width: 100%;
    text-align: center;
    font-size: 0.16rem;
    color: #333;
    padding-top: 0.44rem;
}
.null_data div {
    width: 1.93rem;
    margin: 0 auto 0.24rem;
}
.charts_bar {
    width: 100%;
    height: 3.3rem;
    margin-top: 0.1rem;
}
.chartBox {
    width: 100%;
    height: 350px;
    margin-bottom: 20px;
    .complaintChartStyle {
        width: 100%;
        height: 300px;
    }
    .jiaoStyle {
        height: 348px;
    }
    .chartStyle4 {
        height: 400px;
    }
}
.singleStyle {
    .complaintChartStyle {
        height: 300px;
        /deep/ canvas {
            height: 300px !important;
        }
    }
}
.tableBox {
    margin-bottom: 20px;
    height: 8.7rem;
    .jiaoStyle {
        height: 468px;
    }
    .chartTitle {
        margin-bottom: 10px;
    }
}

.tablesBox {
    // margin-bottom: 20px;
    .chartTitle {
        margin-bottom: 10px;
    }
    .left_tableBox {
        width: 60%;
        min-height: 6.3rem;
        .jiaoStyle {
            height: 338px;
        }
        /deep/ .fontTableStyle {
            th.el-table__cell {
                > .cell {
                    font-size: 16px;
                }
            }
        }
    }
    .right_tableBox {
        width: 40%;
        min-height: 6.3rem;
        .jiaoStyle {
            height: 340px;
        }
        .complaintChartStyle {
            width: 100%;
            min-height: 5.1rem;
        }
    }
}
.wrap {
    width: 100%;
    /* height: 100%; */
    position: relative;
    padding: 0 !important;
}

.editBox {
    margin-bottom: 20px;
    .left_edit {
        width: 59%;
    }
    .right_edit {
        width: 39%;
    }
}
</style>
